import moment from "moment";
import printer from "@/service/printer";
export default {
  mounted() {
    window.addEventListener("focus", this.refreshList);
    window.addEventListener("mousemove", this.resetInactivityTimer);
    window.addEventListener("keydown", this.resetInactivityTimer);
    window.addEventListener("touchstart", this.resetInactivityTimer);
    this.$store
      .dispatch("fetch_contabili", {
        inizio: this.getInizioTs(),
        fine: moment().format("X"),
      })
      .then(() => {
        this.loading = false;
        this.refreshList();
      });
  },
  beforeDestroy() {
    window.removeEventListener("focus", this.refreshList);
    window.removeEventListener("mousemove", this.resetInactivityTimer);
    window.removeEventListener("keydown", this.resetInactivityTimer);
    window.removeEventListener("touchstart", this.resetInactivityTimer);
  },
  data() {
    return {
      loading: true,
      dialog: false,
      soloNonSaldati: true,
      raggruppaPerCliente: false,
      filtraPerDdt: false,
      cliente: null,
      contabili: [],
      unfilteredContabili:[],
      periodoItems: [
        { nome: "Inizio Anno", value: "anno" },
        { nome: "Ultimi 30 giorni", value: 30 },
        { nome: "Ultimi 60 giorni", value: 60 },
        { nome: "Ultimi 90 giorni", value: 90 },
        { nome: "Ultimi 180 giorni", value: 180 },
        { nome: "Ultimo Anno", value: 360 },
        { nome: "Tutti", value: 9999 },
      ],
      periodo: "anno",
      tipoItems: [
        { nome: "Entrambi", value: 0 },
        { nome: "Solo Verde", value: 1 },
        { nome: "Solo Blu", value: 2 },
      ],
      tipo: 0,
      dialogInattivita: false,
      inactivityTimer: null,
    };
  },
  watch: {
    soloNonSaldati() {
      this.refreshList();
    },
    cliente() {
      this.refreshList();
    },
    tipo() {
      this.refreshList();
    },
    periodo() {
      this.$store
        .dispatch("fetch_contabili", {
          inizio: this.getInizioTs(),
          fine: moment().format("X"),
        })
        .then(() => {
          this.loading = false;
          this.refreshList();
        });
    },
  },
  computed: {
    groupedByCliente() {
      let grouped = {};
      this.contabili.forEach((contabile) => {
        if (!grouped[contabile.cliente]) {
          grouped[contabile.cliente] = {
            contabili: {},
            totale: 0,
            tot_blu: 0,
            tot_verde: 0,
          };
        }
        const month = moment(contabile.ts * 1000).format("MMMM YY");
        if (!grouped[contabile.cliente].contabili[month]) {
          grouped[contabile.cliente].contabili[month] = {
            contabili: [],
            totale: 0,
            tot_blu: 0,
            tot_verde: 0,
          };
        }
        grouped[contabile.cliente].contabili[month].contabili.push(contabile);
        grouped[contabile.cliente].contabili[month].totale += contabile.importo;
        grouped[contabile.cliente].contabili[month].tot_verde += contabile.verde
          ? contabile.importo
          : 0;
        grouped[contabile.cliente].contabili[month].tot_blu +=
          contabile.tipo === 1 && !contabile.verde ? contabile.importo : 0;
        grouped[contabile.cliente].totale += contabile.importo;
        grouped[contabile.cliente].tot_verde += contabile.verde
          ? contabile.importo
          : 0;
        grouped[contabile.cliente].tot_blu +=
          contabile.tipo === 1 && !contabile.verde ? contabile.importo : 0;
      });

      // Ordina le contabili di ogni mese per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((cliente) => {
        Object.keys(grouped[cliente].contabili).forEach((month) => {
          grouped[cliente].contabili[month].contabili.sort((a, b) => {
            const numA = parseInt((a.ddt || "").split("/")[0], 10);
            const numB = parseInt((b.ddt || "").split("/")[0], 10);
            return numA - numB;
          });
        });
      });

      return grouped;
    },
    groupedByDay() {
      let grouped = {};
      this.contabili.forEach((contabile) => {
        const day = moment(contabile.ts * 1000).format("dddd DD MMMM YYYY");
        if (!grouped[day]) {
          grouped[day] = {
            contabili: [],
            totale: 0,
            tot_verde: 0,
            tot_blu: 0,
          };
        }
        grouped[day].contabili.push(contabile);
        grouped[day].totale += contabile.importo;
        grouped[day].tot_verde += contabile.verde ? contabile.importo : 0;
        grouped[day].tot_blu +=
          contabile.tipo === 1 && !contabile.verde ? contabile.importo : 0;
      });

      // Ordina le contabili di ogni giorno per il numero prima dello slash nel ddt
      Object.keys(grouped).forEach((day) => {
        grouped[day].contabili.sort((a, b) => {
          // Estrai il numero prima dello slash
          const numA = parseInt((a.ddt || "").split("/")[0], 10);
          const numB = parseInt((b.ddt || "").split("/")[0], 10);
          return numA - numB;
        });
      });

      return grouped;
    },
    filterByDdt(){

      // Prende solo le contabili con DDT valorizzato e le ordina per numero (parte prima dello slash) decrescente
      const withDdt = this.unfilteredContabili
        .filter((contabile) => contabile.ddt && contabile.ddt.trim() !== "")
        .map((c) => ({
          item: c,
          num: parseInt((c.ddt || "").split("/")[0], 10),
        }))
        .filter(({ num }) => !isNaN(num))
        .sort((a, b) => b.num - a.num);

      if (withDdt.length === 0) return [];

      // Inserisce record fittizi per ogni "buco" nel progressivo dei DDT
      const result = [];
      let prevNum = null;
      withDdt.forEach(({ item, num }, idx) => {
        if (idx === 0) {
          // Primo elemento, nessun gap da riempire prima
          result.push(item);
          prevNum = num;
          return;
        }

        // Se esiste un buco tra prevNum e num, aggiungi i record mancanti
        for (let missing = prevNum - 1; missing > num; missing--) {
          result.push({
            id: `missing-${missing}`,
            fake: true,
            ddt: String(missing),
            note: "",
            importo: 0,
            tipo: 1,
            verde: false,
            cliente: null,
            id_ordine: null,
            saldato: false,
            ts: null,
            ts_saldo: null,
          });
        }

        result.push(item);
        prevNum = num;
      });

      return result;

    },
    clienti() {
      return this.$store.getters.get_clienti;
    },
  },
  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = setTimeout(() => {
        this.dialogInattivita = true;
      }, 60000); // 1 minuto di inattività
    },
    continua_navigazione() {
      this.dialogInattivita = false;
      this.resetInactivityTimer();
      this.refreshList();
    },
    refreshList() {
      let array = [...this.$store.getters.get_contabili].sort((a, b) => {
        return b.ts - a.ts;
      });
      this.unfilteredContabili = array;
      if (this.tipo == 1) {
        array = array.filter((contabile) => {
          return contabile.verde == true;
        });
      } else if (this.tipo == 2) {
        array = array.filter((contabile) => {
          return contabile.verde == false;
        });
      }
      if (this.cliente) {
        array = array.filter((contabile) => {
          return contabile.cliente == this.cliente;
        });
      }
      if (this.soloNonSaldati) {
        this.contabili = array.filter((contabile) => {
          return !contabile.saldato;
        });
      } else {
        this.contabili = array;
      }
    },
    getCliente(iva) {
      return this.$store.getters.get_cliente_by_iva(iva);
    },
    stampaEstrattoContoCliente(iva) {
      const coloreMap = { 1: 'verde', 2: 'blu' };
      printer.print_estratto_conto(iva, this.getInizioTs(), moment().format("X"), coloreMap[this.tipo] || null);
    },
    getInizioTs() {
      if (this.periodo === "anno") {
        return moment().startOf("year").format("X");
      }
      if (this.periodo === 9999) {
        return moment("2000-01-01").format("X");
      }
      return moment().subtract(this.periodo, "days").format("X");
    },
  },
};
